import { render, staticRenderFns } from "./OTDiagnosticTechnicianForm.vue?vue&type=template&id=e4b24eb0&scoped=true&lang=pug"
import script from "./OTDiagnosticTechnicianForm.vue?vue&type=script&lang=js"
export * from "./OTDiagnosticTechnicianForm.vue?vue&type=script&lang=js"
import style0 from "./OTDiagnosticTechnicianForm.vue?vue&type=style&index=0&id=e4b24eb0&prod&lang=scss&scoped=true"
import style1 from "./OTDiagnosticTechnicianForm.vue?vue&type=style&index=1&id=e4b24eb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b24eb0",
  null
  
)

export default component.exports